import Backbone from 'backbone';

// Both transfer entry points share this modal and the transfer endpoint. From a kiosk's menu
// (`kiosk` set) the user picks the target location; from the kiosk list the target is the current
// location and the user enters the serial number.
app.KioskTransferModal = Backbone.View.extend({
  className: 'kiosk-transfer-modal',

  initialize(options) {
    this._kiosk = options.kiosk;
    this._onTransfer = options.onTransfer;
  },

  setSuperView(superView) {
    this.superView = superView;
  },

  clearState() {
    this.superView = null;
  },

  _transfer($transferButton, serialNumber, targetLocationId) {
    if (!serialNumber || !targetLocationId) {
      new app.AlertView().show(
        this._kiosk ? 'Please choose a location.' : 'Please enter a serial number.',
      );
      return;
    }

    const reqId = $transferButton.initLoadingButton(
      $transferButton.html(),
      'Transferring...',
      'Transferred!',
    );
    app.makeRequestWithOptions({
      method: 'POST',
      url: '/api/v2/kiosks/transfer',
      data: { serialNumber, targetLocationId },
      onSuccess: () => {
        $transferButton.loadingDidFinishSuccessfully(reqId);
        this.trigger(app.ModalView.Events.ModalViewShouldHide, this);
        this._onTransfer();
      },
      onFailure: () => {
        $transferButton.loadingDidFinishWithError(reqId);
        // A device manager error arrives after the kiosk has moved.
        this._onTransfer();
      },
    });
  },

  _renderLocationPicker($transferButton) {
    const $select = $('<select class="form-select mb-3" disabled></select>');
    this.$el.append(
      $('<p class="text-muted"></p>').text(
        'Only locations in this org with the same channel type that are not live appear here.',
      ),
      $select,
    );

    const sourceLocationId = this._kiosk.get('locationId');
    const locationList = new app.LocationList();
    locationList.fetch({
      success: () => {
        const sourceLocation = locationList.get(sourceLocationId);
        const targetLocations = locationList.filter((location) => {
          return (
            location.get('orgId') === app.org.id &&
            location.id !== sourceLocationId &&
            location.get('orderChannel') === sourceLocation?.get('orderChannel') &&
            !location.isLive()
          );
        });
        if (!targetLocations.length) {
          $select.replaceWith($('<p></p>').text('No location in this org can receive this kiosk.'));
          $transferButton.prop('disabled', true);
          return;
        }
        targetLocations.forEach((location) => {
          $select.append($('<option></option>').val(location.id).text(location.displayName()));
        });
        $select.prop('disabled', false);
      },
    });

    $transferButton.click(() => {
      this._transfer($transferButton, this._kiosk.get('serialNumber'), $select.val());
    });
  },

  _renderSerialNumberField($transferButton) {
    const $input = $('<input type="text" class="form-control mb-3" placeholder="Serial number">');
    this.$el.append(
      $('<p class="text-muted"></p>').text(
        'The kiosk must be in this org, at a location with the same channel type that is not live.',
      ),
      $input,
    );

    $transferButton.click(() => {
      this._transfer($transferButton, ($input.val() || '').trim(), app.location.id);
    });
  },

  render() {
    this.superView.footer.$el.hide();
    const $transferButton = $(
      '<button type="button" class="btn btn-sm btn-primary">Transfer</button>',
    );

    if (this._kiosk) {
      this.superView.$titleLabel.text(`Transfer ${this._kiosk.displayName()} to a Location`);
      this._renderLocationPicker($transferButton);
    } else {
      this.superView.$titleLabel.text(`Transfer a Kiosk to ${app.location.displayName()}`);
      this._renderSerialNumberField($transferButton);
    }
    this.$el.append($transferButton);

    return this;
  },
});
